import { useParams } from 'react-router-dom'
import { FileText, Download, Upload } from 'lucide-react'
import { useDocuments } from '@/hooks/useDocuments'
import { timeAgo, formatBytes } from '@/lib/utils'

export default function ProgramPage() {
  const { slug = '' } = useParams<{ slug: string }>()
  const label = slug.toUpperCase()
  const { documents, loading } = useDocuments({ program: slug })

  return (
    <div className="p-6 max-w-4xl">
      <div className="mb-6">
        <p className="text-xs text-gray-400 uppercase tracking-wider mb-1">Program</p>
        <h1 className="text-xl font-bold text-gray-800 dark:text-white">{label}</h1>
      </div>

      {loading ? (
        <div className="flex flex-col gap-3">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="h-20 bg-gray-100 dark:bg-gray-800 rounded-xl animate-pulse" />
          ))}
        </div>
      ) : documents.length === 0 ? (
        <div className="flex flex-col items-center py-16 text-center">
          <Upload size={36} className="text-gray-300 mb-3" />
          <p className="text-sm text-gray-500">Belum ada dokumen untuk program {label}.</p>
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {documents.map(doc => (
            <div key={doc.id} className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 p-4 flex items-start gap-4 hover:border-cerah-teal/30 transition-colors">
              <div className="w-10 h-10 rounded-lg bg-cerah-teal-light flex items-center justify-center shrink-0">
                <FileText size={20} className="text-cerah-teal" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-gray-800 dark:text-white">{doc.title}</p>
                {doc.description && <p className="text-xs text-gray-500 mt-0.5 line-clamp-2">{doc.description}</p>}
                <div className="flex items-center gap-3 mt-2">
                  <span className="text-[10px] text-gray-400">{timeAgo(doc.created_at)}</span>
                  {doc.file_size && <span className="text-[10px] text-gray-400">{formatBytes(doc.file_size)}</span>}
                </div>
              </div>
              {doc.file_url && (
                <a href={doc.file_url} target="_blank" rel="noopener noreferrer" className="text-xs text-cerah-teal hover:underline flex items-center gap-1">
                  <Download size={14} /> Unduh
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
